<h1 mat-dialog-title>

    <b>Validar Pago Cuota Préstamo</b></h1>
<br/>
<form #validarForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} {{data.apellidoUsuario}}</mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cuota a pagar </mat-label>
                <mat-option> {{data.numCuota}} </mat-option>

            </form-field>
        </p>

        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Total Cuota </mat-label>
                <mat-option> {{data.montoCuota}} </mat-option>

            </form-field>
        </p>
       
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
             
                <mat-label> Fecha Pago </mat-label>
    
                <input  name = "fechaPago" matInput type = "date" placeholder = "Fecha Pago" [(ngModel)] = "data.fechaPago"
                 required #fechaPago = "ngModel">
    
            </mat-form-field>
        </p>
     

        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Descargar Comprobante Pago</mat-label>
                <div class="col-lg-6">
                    <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPlanPago)">

                        <i class = "fa fa-download"> </i> Descargar Archivos Ingresado </button>
                </div>

            </form-field>

        </p>
    </dialog-content>
</form>
<br/>
<mat-dialog-actions>
    <div *ngIf="data.mostrarEditar== true">
        <button mat-button class="mat-raised-button btn-success" (click)="onAprobarPagoClick(validarForm)">
            <i class ="fa fa-check"> </i> Aceptar
        </button>

        <button mat-button class="mat-raised-button btn-danger" (click)="onRechazarPagoClick(validarForm)">
            <i class = "fa fa-trash"> </i> Rechazar
        </button>

        <button mat-button class="mat-raised-button btn-secondary" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
    <div *ngIf="data.mostrarEditar == false">


        <button mat-button class="mat-raised-button btn-secondary" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
</mat-dialog-actions>

<br/>